import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter
      .options.list('type', 'Type', TYPE_OPTIONS)
      .multi(true),
    filter.boolean('active', 'Active'),
  ], [])
}

const TYPE_OPTIONS = [
  { label: 'Deals Only', value: 'deals_only' },
  { label: 'Points', value: 'points' },
  { label: 'Master Cashout', value: 'master_cashout' },
]
